import { AI_LABEL_KIND, AI_LABEL_TYPE, AI_LABEL_INFO_PATH } from '@/utils/constants'

const TYPES_SEPARATOR = ','

// Route of the static info page explaining an item's AI label
export const aiLabelInfoRoute = ({ kind, types = [] }) => ({
  path: AI_LABEL_INFO_PATH,
  query: { kind, ...(types.length && { types: types.join(TYPES_SEPARATOR) }) },
})

// Reads the info page query back into { kind, types }; null for an unknown kind. `types` only
// applies to the basic kind, unknown ones are dropped.
export const parseAiLabelQuery = ({ kind, types } = {}) => {
  if (!Object.values(AI_LABEL_KIND).includes(kind)) return null
  if (kind !== AI_LABEL_KIND.basic) return { kind, types: [] }
  const known = Object.values(AI_LABEL_TYPE)
  return { kind, types: String(types ?? '').split(TYPES_SEPARATOR).filter(type => known.includes(type)) }
}
